function EuthanasiaFormField() {
  return (
    <fieldset>
      <label>
        Euthanasia Authorization Form{" "}
        <span className="label-optional">(Optional)</span>
      </label>
      <input
        type="file"
        accept="image/*,.pdf"
        id="euthanasia-authorization-form"
      />
    </fieldset>
  );
}

export default EuthanasiaFormField;
